import { Box, Grid, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import FixedSizeDialog from "components/fixedSizeDialog";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import moment from "moment";
import UploadCreateForm from "../forms/createUploadForm";
import DownloadIcon from "@mui/icons-material/Download";
import { Upload } from "@mui/icons-material";
import { useGetStockTakeUploadList } from "api/hooks/uploads";
import { fileURL, requester } from "api/pesabackend";

export default function StockTakeUploadsTable({ setIsSuccess, setIsFailed }) {
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const { stockTakeUploadList, isLoadingStockTakeUploadList, setNewStockTakeUploadData } =
    useGetStockTakeUploadList(business_branch_id);
  const [open, setOpen] = useState(false);

  const saveUpload = async (values, onSubmitProps) => {
    const savedItemResponse = await requester.post(`/uploads/stock_take/upload`, values, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (savedItemResponse.data.status === 201) {
      setOpen(false);
      onSubmitProps.resetForm();
      setIsSuccess(true);
      setNewStockTakeUploadData(true);
      navigate("/stockTakeUploadProgress", { state: savedItemResponse.data.data });
    }

    if (savedItemResponse.data.status === 400) {
      setIsFailed(true);
    }
  };

  const handleClickDownloadTemplate = async () => {
    const _response = await requester.get(
      `/uploads/stock_take/generate?business_branch_id=${business_branch_id}`
    );
    if (_response.status === 200) {
      const a = document.createElement("a");
      a.href = `${fileURL}/${_response.data.data.file_url}`;
      a.download = _response.data.data.name;
      a.click();
    }
  };

  const handleClickView = (file_data) => {
    navigate("/stockTakeUploadProgress", { state: file_data });
  };

  const uploadedBy = (row) => {
    if (row.uploaded_by?.first_name)
      return `${row.uploaded_by.first_name} ${row.uploaded_by.last_name}`;
    return row.uploaded_by?.username ?? "—";
  };

  return (
    <Box>
      <Typography variant="h3">Uploaded Stock Takes List</Typography>
      <Box p="1rem" m="1rem" borderRadius="0.5rem">
        <Grid container spacing={4} className="alignHorizantal">
          <Grid xs={3} />
          <Grid xs={6} />
          <Grid xs={3} sx={{ textAlign: "right" }}>
            <Button
              variant="contained"
              endIcon={<DownloadIcon />}
              onClick={handleClickDownloadTemplate}
            >
              DOWNLOAD TEMPLATE
            </Button>
            <Button
              sx={{ mx: "5px" }}
              endIcon={<Upload />}
              variant="contained"
              onClick={() => setOpen(true)}
            >
              UPLOAD FILE
            </Button>
            <FixedSizeDialog
              dialogHeading="Upload File Form"
              open={open}
              handleClose={() => setOpen(false)}
              negativeResponse="Cancel"
              maxWidth="md"
              scroll="body"
              content={
                <Box p="1rem" borderRadius="0.5rem">
                  <UploadCreateForm setOpen={setOpen} saveItem={saveUpload} />
                </Box>
              }
            />
          </Grid>
        </Grid>
      </Box>

      <Box>
        <ReportTable
          columns={[
            { label: "Date Uploaded" },
            { label: "File Status" },
            { label: "Number of Records" },
            { label: "Uploaded By" },
            { label: "Actions", align: "center" },
          ]}
          rows={stockTakeUploadList}
          loading={isLoadingStockTakeUploadList}
          emptyMessage="No data found"
          renderRow={(row, index) => (
            <RRow key={row.id} index={index}>
              <RCell>{moment(row.date_added).format("LLL")}</RCell>
              <RCell>{row.processed_status ? "PROCESSED" : "NOT PROCESSED"}</RCell>
              <RCell>{row.number_of_rows}</RCell>
              <RCell>{uploadedBy(row)}</RCell>
              <RCell align="center">
                <Button size="small" onClick={() => handleClickView(row)}>
                  View Details
                </Button>
              </RCell>
            </RRow>
          )}
        />
      </Box>
    </Box>
  );
}
